<script>
import axios from '@/utils/axios';
import { wById } from '@/utils/warehouse.js';

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "Inventory",
   text: "Inventory",
   app_currency: '',
   data: [],
   status: '',
   search: '',
   pagination: {
    current_page: 1,
    per_page: 25,
    last_page: 1,
    total: 0,
    links: []
   },
   warehouse: '',
   inventory_type: '',
  };
},

computed: {
  text1(){
   return `Warehouse Items (${this.pagination.total})`; 
  },
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page; 
  }
},

async mounted() {
 const warehouse_id = this.$route.params.warehouse_id;  
 this.warehouseById(warehouse_id); 
 this.warehouseItems(warehouse_id);
 this.app_currency = await this.$appCurrency();
}, 

methods: {

 async warehouseById(warehouse_id){
  try{
   const response = await wById(warehouse_id);
   this.warehouse = response.data.data;
  }catch(error){
   this.$swalToast(error.message, 'error');
  }
 }, 

 async warehouseItems(warehouse_id, page = 1){
  this.setLoading(true);
   try{
    const params = {
     page,
     search: this.search.trim() || '' 
    };
    if (this.inventory_type) params.inventory_type = this.inventory_type;
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/inventory/stocks/warehouse-items/${warehouse_id}?${query_string}`);
    this.data = response.data.data.data;
    this.pagination = {
     current_page: response.data.data.current_page,
     per_page: response.data.data.per_page,
     last_page: response.data.data.last_page,
     total: response.data.data.total,
     links: response.data.data.links 
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
 },

 changePage(url){
  if(!url) return;
  const page = new URL(url).searchParams.get("page");
  this.warehouseItems(page);
 },

clearFilter(){
  this.status = '';
  this.search = '';
  this.inventory_type = '';
  const warehouse_id = this.$route.params.warehouse_id;
  this.warehouseItems(warehouse_id, 1); 
}

 },
};
</script>


<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
 
 <div class="">
  <router-link :to="{name: 'warehouses'}" class="btn btn-primary btn-sm">
   <i class="ti ti-chevrons-left"></i> Warehouses
  </router-link>
 </div> 

</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5><span class="text-primary">{{ warehouse?.name }}</span> Warehouse Items List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">

  <div class="me-3">
  <vue-select
    v-model="inventory_type"
    :options="[
      { label: 'Raw', value: 'raw' },
      { label: 'Finish', value: 'finish' },
    ]"
    label="label"
    :reduce="o => o.value"
    placeholder="Inventory Type"
    :clearable="true"
    @update:modelValue="warehouseItems(1)"
    style="min-width: 150px;"
  ></vue-select>
</div>
    
    <div class="me-3" v-if="search || status || inventory_type">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="warehouseItems($route.params.warehouse_id, 1)"><i class="ti ti-search"></i></button>
    </div>

  </div>
 </div>

  <div class="card-body p-0">
  <div class="custom-datatable-filter table-responsive">
    <table class="table datatable thead-light" v-if="data?.length">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Price</th>
          <th>Qty on hand</th>
          <th>Available Qty</th>
          <th>Reserved</th>
          <th>Opening Balance</th>
          <th>On Order Qty</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
        <td>{{ serialNo + index + 1 }}.</td>  
        <td> {{ row?.item?.name }} 
          <div>
            <a class="badge bg-light text-primary border rounded-pill me-1 mb-1 text-capitalize" @click="$copyText(row?.code)"> {{ row?.item?.code }} </a>
            <small class="text-muted d-block" style="font-size:11px;">Brand: {{ row?.item?.brand?.name || 'NA' }}</small>
            <span v-if="row?.item?.inventory_type" 
              class="badge rounded-pill mt-1"
              :class="row?.item?.inventory_type === 'raw' ? 'bg-warning-subtle text-warning' : 'bg-success-subtle text-success'">
              {{ row?.item?.inventory_type === 'raw' ? 'Raw' : 'Finish' }}
            </span>
          </div>
        </td>
        <td>{{ this.app_currency.symbol+row?.item?.price }}</td>
        <td>{{ parseInt(row.qty_on_hand) }}</td>
        <td>
        <span class="badge"
          :class="parseInt(row.available_qty) > 0 
            ? 'bg-success-transparent text-success' 
            : 'bg-danger-transparent text-danger'">
          {{ parseInt(row.available_qty) }}
        </span>
      </td>
        <td>{{ parseInt(row.reserved) }}</td>
        <td>{{ parseInt(row.opening_balance) }}</td>
        <td>{{ parseInt(row.on_order) }}</td>
        <td>
        <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">

        <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);"><i class="ti ti-edit me-1"></i>No Action</a>
        </li>
        
        </ul>
        </div>  

        </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="p-3 text-center text-muted"> No records found. </div>
  </div>

  <!-- Pagination -->
  <nav v-if="pagination.links.length > 3" class="m-3">
    <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>
  </div>

</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

</template>
<style scoped>
    .table-responsive {
        overflow-y: auto;
    }
</style>